import { appConfig } from "../../configs";

const apiVersion = appConfig.apiVersion;

const identityApiBaseUrlVersionParam = appConfig.identityApiBaseUrl;

export const identityApiBaseUrl = identityApiBaseUrlVersionParam.replace(
  "{apiVersion}",
  apiVersion
);

const merchantApiBaseUrlVersionParam = appConfig.merchantApiBaseUrl;

export const merchantApiBaseUrl = merchantApiBaseUrlVersionParam.replace(
  "{apiVersion}",
  apiVersion
);
